import React from 'react';
import View from "../View/View";
import {
  withFormControl,
  PuzzleButton,
  Container,
  PuzzleToolbar
} from "puzzle";
import SubmissionAbstract from "../SubmissionAbstract";
import { config, tptTemplateConfig } from "../TemplateCreate/TemplateCreate.config";
import { CREATE_STATE } from "../Types";

export type PROPS = {
  submissionMode: boolean
};

class TemplateEdit extends SubmissionAbstract<PROPS, CREATE_STATE> {

  static defaultProps = {
    submissionMode: 'TEMPLATE_EDIT',
  };

  state: any = {
    ...this.state,
    editTemplateEnabled: true
  }

  /**
   * Manage disabled state of buttons
   * @param projectId
   */
  validateButtons = (projectId = this.state.initEditData?.projectId) => {
    const editTemplateEnabled = projectId === this.state.initEditData?.projectId;
    this.setState({ editTemplateEnabled })
  }

  /**
   * Cancel button handler, prompts warning window and redirects to previous path
   */
  onCancel = () => {
    this.dispatch('checkForChangesBeforeRedirect', '', { leaveAction: 'goBack' })
  }

  renderBody() {
    const { submissionId } = this.state;
    return (
      <Container vBox className={'tp-page tp-templateEdit-page'}>
        <Container
          alignItemsCenter
          displayFlex
          justifyContentBetween
          wrap
          className={'tp-page-header'}
        >
          <h2 className={'tp-page-title'}>
            {this.translate('editTemplate')}
          </h2>
          <PuzzleToolbar className={'tp-page-header-action-toolbar'}>
            <PuzzleButton
              fillMode={'outline'}
              onClick={this.onCancel}
            >
              {this.translate('cancel')}
            </PuzzleButton>
            <PuzzleButton
              onClick={this.triggerSubmissionAction.bind(this, 'saveEditSubmission', { submissionId, analyze: false })}
              themeColor={'primary'}
              disabled={!this.state.editTemplateEnabled}
            >
              {this.translate('saveChanges')}
            </PuzzleButton>
            <PuzzleButton
              onClick={this.triggerSubmissionAction.bind(this, 'saveSubmission', {
                submissionId,
                analyze: false,
                staticFields: this.staticFields,
                submissionMode: 'TEMPLATE_CLONE'
              })}
              themeColor={'primary'}
            >
              {this.translate('saveAsNew')}
            </PuzzleButton>
          </PuzzleToolbar>
        </Container>
        <View headerText={this.translate('newSubmission')} isTemplate={true} {...this.props} />
      </Container>
    )
  }
}

const Tpt = withFormControl(tptTemplateConfig, false)(TemplateEdit);
const Client = withFormControl(config, false)(TemplateEdit);

const TemplateEditView = (props: { tptEnabled: boolean }): JSX.Element => {
  let mode = props.tptEnabled ? <Tpt tptEnabled={true} /> : <Client tptEnabled={false} />;
  return mode;
};

export default TemplateEditView;